<app-loading *ngIf="cargando"></app-loading>
<div *ngIf="!cargando">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate>
    <div class="grid form-group">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'REQUISITOTIPOVINCUACION.LBL_TIPOVINCULACION' | translate }}</label>
          <p-multiSelect id="idTipoVinculacion" name="nomTipoVinculacion" [options]="lisTipoVinculacion"
                         filter="filter"
                         defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                         selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
                         formControlName="idTipoVinculacion"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoVinculacion.invalid">
            {{ 'REQUISITOTIPOVINCUACION.LBL_TIPOVINCULACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-6 div-form">
        <label for="cantidad">* {{ 'REQUISITOTIPOVINCUACION.LBL_CANTIDAD' | translate }}</label>

        <input type="text" pInputText id="cantidad"
               name="nomCantidad"
               autocomplete="off"
               formControlName="cantidad" numero-entero-reactive
               [maxlength]="3">

        <div class="p-message p-messages-error p-corner-all"
             *ngIf="submitted && f.cantidad.errors && f.cantidad.errors.required">
          {{ 'REQUISITOTIPOVINCUACION.LBL_CANTIDAD' | translate}} {{ 'LBL_REQUERIDO' | translate}}
        </div>
        <div class="p-message p-messages-error p-corner-all"
             *ngIf="submitted && f.cantidad.errors && (f.cantidad.errors.min || f.cantidad.errors.max)">
          {{ 'REQUISITOTIPOVINCUACION.MSG_ERRORCANTIDAD' | translate:{min: '0', max: '999'} }}
        </div>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                type="button" (click)="onSubmit()"
                pButton></button>
      </div>
    </div>
  </form>


  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6">
    </div>
    <div class="col-12 md:col-6 lg:col-6">
      <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
             (input)="dt.filterGlobal($event.target.value, 'contains')">
    </div>
  </div>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" #dt
               [value]="lisRequisitoCantidad"
               [paginator]="true" [rows]="10" paginatorPosition="bottom"
               [globalFilterFields]="['tiposVinculaciones', 'cantidad']">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.tiposVinculaciones}}</td>
            <td>{{row.cantidad}}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-primary btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_ACTUALIZAR' | translate}}" pButton
                        (click)="editar(row)"></button>
                <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_INHABILITAR' | translate}}" pButton
                        (click)="inhablitar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'REQUISITOTIPOVINCUACION.BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="salir()"></button>
    </div>
  </div>
</div>


<p-confirmDialog #cd key="tipo-vinculacion">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>


<p-dialog header="{{'BTN_ACTUALIZAR' | translate}}" [(visible)]="editarRequisito"
          [contentStyle]="{'width':'600px'}" *ngIf="editarRequisito"
          modal="true">
  <p-tabView>
    <form [formGroup]="formularioDetalle" novalidate>
      <div class="grid">
        <div class="col-12 div-form">
          <label for="cantidadD">{{ 'REQUISITOTIPOVINCUACION.LBL_CANTIDAD' | translate }}</label>
          <input type="number"
                 pInputText id="cantidadD"
                 name="nomCantidadD"
                 autocomplete="off"
                 formControlName="cantidad"
          />
          <div class="p-message p-messages-error p-corner-all"
               *ngIf="submittedD && fd.cantidad.errors && fd.cantidad.errors.required">
            {{ 'REQUISITOTIPOVINCUACION.LBL_CANTIDAD' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
          <div class="p-message p-messages-error p-corner-all"
               *ngIf="submittedD && fd.cantidad.errors && (fd.cantidad.errors.min || fd.cantidad.errors.max)">
            {{ 'REQUISITOTIPOVINCUACION.MSG_ERRORCANTIDAD' | translate:{min: '0', max: '999'} }}
          </div>
        </div>
      </div>
    </form>

  </p-tabView>

  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-save" label="{{ 'BTN_ACTUALIZAR' | translate }}" type="button"
              pButton (click)="modificarCantidad()"></button>
      <button icon="fa fa-close" label="{{ 'BTN_CERRAR' | translate }}" type="button"
              pButton (click)="cerrar()"></button>
    </div>
  </div>
</p-dialog>

